export default "__VITE_ASSET___j6Rop89__"